/**
 * @deprecated Use the new CustomSectionType enum instead
 */
export enum OldCustomSectionType {
  Question = 'question',
  Action = 'action',
  ExtractInfo = 'extract_info',
  Signal = 'signal',
  NonExtract = 'non-extract',
  MeetingDetails = 'meeting_details',
  AccountDetails = 'account_details',
}
/**
 * @deprecated Use the new GroupByOption enum instead
 */
export enum OldGroupByOption {
  Topics = 'Topics',
  Company = 'Company',
  Participants = 'Participants',
  None = 'None',
}
/**
 * @deprecated Use the new AnswerTypeOption enum instead
 */
export enum OldAnswerTypeOption {
  SingleChoice = 'SingleChoice',
  MultiChoice = 'MultiChoice',
}
/**
 * @deprecated Use the new GenerateAsOption enum instead
 */
export enum OldGenerateAsOption {
  Paragraph = 'Paragraph',
  Bullet = 'Bullet',
  Number = 'Number',
  Checklist = 'Checklist',
}
/**
 * @deprecated Use the new ParticipantGroupOption enum instead
 */
export enum OldParticipantGroupOption {
  All = 'All',
  CustomerParticipants = 'CustomerParticipants',
  MyTeam = 'MyTeam',
  Custom = 'Custom',
}
/**
 * @deprecated Use the new CustomSectionConfiguration enum instead
 */
export type OldCustomSectionConfiguration = {
  question?: string;
  aiContext?: string;
  groupBy?: OldGroupByOption;
  generateAs?: OldGenerateAsOption;
  participants?: OldParticipantGroupOption;
  choices?: {
    answerType?: OldAnswerTypeOption;
    choices?: string[];
    id?: string;
    generateNewChoices?: boolean;
  };
  fields?: string[];
};
/**
 * @deprecated Use the new CustomSectionContentState enum instead
 */
export enum OldSectionComponentType {
  Prompt = 'PromptSectionComponent',
  Generated = 'GeneratedSectionComponent',
}

/**
 * @deprecated Use the new CustomSectionAttributes enum instead
 */
type OldCustomSectionAttributes = {
  uuid?: string;
  componentType: OldSectionComponentType;
  sectionType: OldCustomSectionType;
  title?: string;
  payload?: OldCustomSectionConfiguration;
  response?: Record<string, any>;
};

/**
 * @deprecated Use the new CustomSectionNodeType enum instead
 */
export enum OldCustomSectionNodeType {
  AiFillSection = 'aiFillSection',
  BlockDetailsSection = 'blockDetailsSection',
}

/**
 * @deprecated Use the new SectionNode interface instead
 */
export interface OldSectionNode {
  type: OldCustomSectionNodeType;
  attrs: OldCustomSectionAttributes;
  content?: any;
}
